export function formatCurrency(amount: number, currency?: string, locale?: string): string {
  const resolvedLocale = locale || (typeof navigator !== 'undefined' ? navigator.language : 'en-US');
  const resolvedCurrency = currency || (resolvedLocale.startsWith('it') ? 'EUR' : 'EUR');
  try {
    return new Intl.NumberFormat(resolvedLocale, { style: 'currency', currency: resolvedCurrency, maximumFractionDigits: 2 }).format(Number(amount) || 0);
  } catch {
    return `${Number(amount || 0).toFixed(2)} ${resolvedCurrency}`;
  }
}


